export default {
      id: "icon-jaime-usage",
      viewBox: "0 0 181.4 76.5",
      url: __webpack_public_path__ + "icons.svg#icon-jaime",
      toString: function () {
        return this.url;
      }
    }